export const rule_NOTIN = (value1: any, value2: any): boolean => {
    // works for strings and arrays...
    if (Array.isArray(value1) && Array.isArray(value2)) {
        return !value1.some(val => value2.includes(val));
    }

    if (!Array.isArray(value1)) {
        return !value2.includes(value1);
    }

    return false;
}
